/**
 * Created by - Ashlekh on 04-02-2025
 * Reason - To add Event Detailed page
 */

import { useContext, useEffect, useState } from "react";
import style from "./eventDetailed.module.css";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import parse from "html-react-parser";
import { getEventDetailsAPI } from "../../Api/services";
import { useLocation } from "react-router-dom";
import config from "../../Api/config";

const EventDetailed = () => {
  const [eventDetails, setEventDetails] = useState([]);
  const [filteredEventDetails, setFilteredEventDetails] = useState([]);
  const [eventImages, setEventImages] = useState([]);
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const location = useLocation();
  const eventId = location.state;
  // Added by - Ashlekh on 04-02-2025
  // Reason - This useEffect will executes when page loads and set navigation path in page
  useEffect(() => {
    window.scrollTo(0, 0);
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Event", path: "/event" },
      { name: "Event Details", path: "/event_detailed" },
    ]);
  }, []);
  // End of code - Ashlekh on 04-02-2025
  // Reason - This useEffect will executes when page loads and set navigation path in page

  // Added by - Ashlekh on 04-02-2025
  // Reason - This useEffect will executes if eventId is not null or empty
  useEffect(() => {
    if (eventId != null && eventId != "") {
      getEventDetails();
    }
  }, [eventId]);
  // End of code - Ashlekh on 04-02-2025
  // Reason - This useEffect will executes if eventId is not null or empty

  // Added by - Ashlekh on 04-02-2025
  // Reason - To filter details using eventId (when response is sent by api)
  useEffect(() => {
    if (eventDetails.length > 0) {
      const filteredEvent = eventDetails.filter((item) => item.id == eventId);
      setFilteredEventDetails(filteredEvent);
      if (filteredEvent.length > 0) {
        const event = filteredEvent[0];
        setEventImages(
          [
            event.image1,
            event.image2,
            event.image3,
            event.image4,
            event.image5,
          ].filter(Boolean)
        ); // Remove undefined/null values
      }
    }
  }, [eventDetails, eventId]);
  // End of code - Ashlekh on 04-02-2025
  // Reason - To filter details using eventId (when response is sent by api)

  // Added by - Ashlekh on 04-02-2025
  // Reason - To get event details from backend
  const getEventDetails = async () => {
    try {
      const response = await getEventDetailsAPI();
      setEventDetails(response?.event);
    } catch (error) {
      console.error("Error fetching Event details: ", error);
    }
  };
  // End of code - Ashlekh on 04-02-2025
  // Reason - To get event details from backend
  
  return (
    <div className={`${style.mainContainer}`}>
      <NavigationPath navigationPathArray={navigationPath} />
      <div className={`${style.imageContainer}`}>
        {eventImages?.map((image, index) => (
          <div key={index} className={`${style.imageSubContainer}`}>
            <img
              className={`${style.image}`}
              src={config.baseURL + image}
              alt=""
            />
          </div>
        ))}
      </div>
      <div>
        {/* {parse(filteredEventDetails?.description)} */}
        {filteredEventDetails.length > 0 && filteredEventDetails[0]?.description
          ? parse(filteredEventDetails[0].description)
          : null}
      </div>
    </div>
  );
};

export default EventDetailed;
